import React,{useState} from 'react'
import { Row, Col ,Card,CardBody } from "reactstrap";
import GoogleMap from './GoogleMap';
import { CommonModal, P } from "../../AbstractElements";
import MapBox from './MapBox';
const LocateDriver = ({
  Large,title,LargeModaltoggle,
  driverObj,
  cityData
}) => {
  const [mapFlag, setMapFlag] = useState(false);
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="xl"
    >
      <Card className="driver-map-details">
      {/* {mapFlag} */}
      <CardBody className="p-0">
        {/* <div className="custom-toggle-switch">
          <input
            type="checkbox"
            onChange={(e) => {
              setMapFlag(!mapFlag);
            }}
            id="switch"
          />
          <label htmlFor="switch"></label>
        </div> */}

        {/* <div class="custom-control custom-switch">
  <input type="checkbox" class="custom-control-input" id="customSwitch1"/>
  <label class="custom-control-label" for="customSwitch1">Toggle this switch element</label>
</div>
<div class="custom-control custom-switch">
  <input type="checkbox" class="custom-control-input" disabled id="customSwitch2"/>
  <label class="custom-control-label" for="customSwitch2">Disabled switch element</label>
</div> */}
        {/* <MapContainer style={{ height: "100%", width: "100%" }} zoom={13} scrollWheelZoom={false}>
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  />
 <LeafletControlGeocoder positionInfos={positionInfos} />
</MapContainer> */}
        {mapFlag ? <GoogleMap driverObj={driverObj} Large={Large} cityData={cityData} />:<MapBox driverObj={driverObj} Large={Large} cityData={cityData} />}
      </CardBody>
    </Card>
    </CommonModal>
  )
}

export default LocateDriver;